let conf = {}

if (typeof window !== 'undefined' && window.mtConf != null) {
  conf = window.mtConf
}

module.exports = conf
